module.exports = __webpack_public_path__ + "img/15.65a2433c.jpg";